import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { MemberGetMemberState } from './member-get-member-state.reducer';

export const memberGetMemberSelectorKey = 'member-get-member';

export const getMemberGetMemberState =
  createFeatureSelector<MemberGetMemberState>(memberGetMemberSelectorKey);

export const getSaleId = createSelector(
  getMemberGetMemberState,
  (state) => state.saleId
);

export const hasMemberGetMember = createSelector(
  getSaleId,
  (mgmSaleId) => !!mgmSaleId
);

export const getCustomerDetails = createSelector(
  getMemberGetMemberState,
  (state) => ({
    customerName: state.customerName,
    customerEmail: state.customerEmail,
  })
);
